// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const QueueHeader = styled.div`
  display: flex;
  align-items: flex-start;
  padding-bottom: 16px;
`;
QueueHeader.displayName = 'S.QueueHeader';

export const LefthandPanel = styled.div``;
LefthandPanel.displayName = 'S.LefthandPanel';

export const RighthandPanel = styled.div`
  text-align: right;
  flex: 1 1 auto;
`;
RighthandPanel.displayName = 'S.RighthandPanel';

export const QueueNamePanel = styled.div`
  flex: 1 1 auto;
  display: flex;
  align-items: center;
`;
QueueNamePanel.displayName = 'S.QueueName';

export const QueueName = styled.span`
  font-size: 24px;
  font-weight: 600;
  line-height: 32px;
  margin-right: 8px;
`;
QueueName.displayName = 'QueueName';
